const variables = {
  headerHeight: '64px',
  footerHeight: '40px',
  drawerRootWidth: '240px',
  drawerWidth: '0px',
  closedDrawerWidth: '0px',
  tableToolBarHeight: '56px',
};

export default variables;
